import { useState, useEffect } from 'react'
import { useLocation } from '@reach/router'

const useRouteHistory = () => {
  const location = useLocation()
  const [history, setHistory] = useState([])

  useEffect(() => {
    setHistory(prevHistory => [...prevHistory, location.pathname])
  }, [location])

  return history
}

export default useRouteHistory
